export type AddCookies = {
    client_token:string
    cookies:string
}
export enum OrderStatus {
    "New"= 1,
    "Build" = 2,
    "Collected" = 3,
    "Sended" = 4,
    "Cancel" = 6
}
export enum MarketPlace  {
    "WB" = 1,
    "OZON" = 2
}
export type UpdateOrderStatus = {
    status_id:OrderStatus,
    marketplace_id:MarketPlace,
    order_ids?:string[]
    filters?:any
    /** Причина отмены — только для OZON, Wildberries отменяется без неё */
    cancel_reason_id?:number
    cancel_reason_message?:string
}

/** Причина отмены отправления OZON, доступная для выбранных заказов */
export type OzonCancelReason = {
    id:number
    name:string
    /** По этой причине OZON требует пояснение текстом */
    needs_message:boolean
}
export type SyncSupplier = {
    supply_id :string,
    day:number,
}
export type TransferToDelivery = {
    supply_id :number,
    marketplace_id:MarketPlace,
    partner_id ?:number[]
    ids ?:string[]
}
export type PrintLabel = {
    order_ids?:string[]
    filters?:any
}
